module.exports = __webpack_public_path__ + "static/media/Free_Events_m_mr.102f82af.jpg";